import React from 'react';
import styled from 'styled-components';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';
import Button from './atom/Button';

export interface Props extends React.ComponentPropsWithoutRef<'button'> {
  padding: PaddingProps;
  rounded?: keyof Theme['rounded'];
  gap?: keyof Theme['gap'];
  textSize?: keyof Theme['size'];
  fontWeight?: keyof Theme['font'];
  variant: 'primary' | 'secondary';
  icon?: React.ReactNode;
}

const Arrow = styled.svg`
  ${(p) => p.theme.transition.all};
  width: 1.5em;
  height: 1.5em;
`;

const StyledButton = styled(Button)<{ $padding: PaddingProps }>`
  padding: ${(p) =>
    typeof p.$padding === 'object'
      ? `${p.theme.size[p.$padding.y]} calc(${p.theme.size[p.$padding.x]} - 0.25em) ${p.theme.size[p.$padding.y]} ${p.theme.size[p.$padding.x]}`
      : `${p.theme.size[p.$padding]} calc(${p.theme.size[p.$padding]} - 0.25em) ${p.theme.size[p.$padding]} ${p.theme.size[p.$padding]}`};
  &:hover:not(:disabled) > ${Arrow} {
    transform: translateX(4px);
  }
`;

export default React.forwardRef(function ButtonWithArrow(
  {
    padding,
    rounded,
    gap,
    textSize,
    fontWeight,
    variant,
    icon,
    children,
    ...props
  }: Props,
  ref: React.Ref<HTMLButtonElement>
) {
  return (
    <StyledButton
      ref={ref}
      $variant={variant}
      $padding={padding}
      $rounded={rounded}
      $fontWeight={fontWeight}
      $gap={gap ?? 'xxxs'}
      $textSize={textSize}
      {...props}
    >
      {children}
      {icon}
    </StyledButton>
  );
});
